"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _components = require("@folio/stripes/components");
var _utils = require("../utils");
var _hooks = require("../hooks");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SettingPagePane = _ref => {
  let {
    children,
    intlKey: passedIntlKey,
    intlNS: passedIntlNS,
    sectionName
  } = _ref;
  const kintIntl = (0, _hooks.useKintIntl)(passedIntlKey, passedIntlNS);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Pane, {
    defaultWidth: "fill",
    id: `settings-${sectionName}`,
    paneTitle: kintIntl.formatKintMessage({
      id: `settings.settingsSection.${(0, _utils.toCamelCase)(sectionName)}`,
      fallbackMessage: sectionName
    }),
    children: children
  });
};
SettingPagePane.propTypes = {
  sectionName: _propTypes.default.string,
  intlKey: _propTypes.default.string,
  intlNS: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.node])
};
var _default = exports.default = SettingPagePane;